import { render, staticRenderFns } from "./InspectionTemplateDetail.vue?vue&type=template&id=53273fca&"
import script from "./InspectionTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./InspectionTemplateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports